import commonRoutingService from 'common/services/commonRoutingService';

const urlContextParametersService = {
    setContextId(contextId: number, silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString({ contextId, scorableItem: null, sectionId: null }, silent);
    },

    setQtiContextItemId(qtiContextItemId: number, silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString({ qtiContextItemId, resourceContextItemId: undefined }, silent);
    },

    setCurrentScorableItemId(scorableItemContextId: number | string, key?: string, silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString(
            key ? { [key]: scorableItemContextId } : { scorableItemContextId },
            silent
        );
    },

    setContentType(contentType: string, silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString(
            { contentType },
            silent
        );
    },

    resetScorableItemContextId(silent?: boolean, key?: string): void {
        commonRoutingService.setNewUrlSearchString(
            key ? { [key]: undefined } : { scorableItemContextId: undefined },
            silent
        );
    },

    resetScorableItemBasedOnFeatureId(): void {
        const urlObj = new URL(window.location.href);
        const params = urlObj.searchParams;

        for (const key of params.keys()) {
            if (key.includes('scorableItemContextId-')) {
                urlContextParametersService.resetScorableItemContextId(true, key);
            }
        }
    },

    resetContentType(silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString(
            { contentType: undefined },
            silent
        );
    },

    setResourceContextItemId(resourceContextItemId: number, silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString({ resourceContextItemId, qtiContextItemId: undefined, link: undefined }, silent);
    },

    resetQtiContextItemIdAndResourceContextItemId(silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString({ qtiContextItemId: undefined, resourceContextItemId: undefined, link: undefined }, silent);
    },

    resetScorableItem(): void {
        commonRoutingService.setNewUrlSearchString({ scorableItem: null });
    },

    resetQuestionIdAndScorableItemAndSectionId(): void {
        commonRoutingService.setNewUrlSearchString({ questionId: null, scorableItem: null, sectionId: null });
    },

    setResourceLink(link: string, silent?: boolean): void {
        commonRoutingService.setNewUrlSearchString({ link, qtiContextItemId: undefined, resourceContextItemId: undefined }, silent);
    },
};

export default urlContextParametersService;
